import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, update, set, child, remove, push, ref, off } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  import { buildActiveVehicleAtomicPayload, buildDriverOfflineAtomicPayload } from '../other/authHelpers';
  
  let activeCarsQuery = null;
  let activeDriverIdQuery = null;
  let activeDriverQuery = null;
  const carSubscribers = new Set();

  /**
   * Désabonne proprement les écouteurs temps réel de véhicules par identifiant d'écran / composant.
   * Si d'autres écrans sont encore abonnés, les écouteurs restent actifs pour eux.
   * export const clearFetchCars = () => () => {
   */
  export const clearFetchCars = (subscriberId = 'default') => () => {
    if (subscriberId && subscriberId !== '__ALL__') {
      carSubscribers.delete(subscriberId);
    }
    // Nettoyer uniquement si aucun abonné ne subsiste ou si forcé par __ALL__
    if (subscriberId === '__ALL__' || carSubscribers.size === 0 || !subscriberId) {
      carSubscribers.clear();
      try {
        if (activeCarsQuery) {
          off(activeCarsQuery);
          activeCarsQuery = null;
        }
      } catch (_) {}
      try {
        if (activeDriverIdQuery) {
          off(activeDriverIdQuery);
          activeDriverIdQuery = null;
        }
      } catch (_) {}
      try {
        if (activeDriverQuery) {
          off(activeDriverQuery);
          activeDriverQuery = null;
        }
      } catch (_) {}
    }
  };

  export const fetchCars = (subscriberId = 'default') => (dispatch, getState) => {
    if (subscriberId) {
      carSubscribers.add(subscriberId);
    }
  
    const {
        carsRef,
        carsRefDriver,
        carsRefDriverId,
        auth
    } = firebase;
  
    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const state = typeof getState === 'function' ? getState() : (store ? store.getState() : {});
    const userInfo = state?.auth?.profile;

    if (!userInfo || !userInfo.uid) {
      return;
    }

    const carsById = new Map();

    // Pre-populate from auth.profile.cars if already present in Redux state
    if (userInfo.cars && typeof userInfo.cars === 'object') {
      Object.keys(userInfo.cars).forEach(id => {
        if (userInfo.cars[id] && typeof userInfo.cars[id] === 'object') {
          carsById.set(id, { ...userInfo.cars[id], id });
        }
      });
    }

    const emitCars = () => {
      let arr = Array.from(carsById.values());
      if (userInfo?.usertype === 'driver') {
        arr = arr.filter(c => c && (c.driver === userInfo.uid || c.driverId === userInfo.uid || c.driver_uid === userInfo.uid));
      } else if (userInfo?.usertype === 'fleetadmin') {
        arr = arr.filter(c => c && c.fleetadmin === userInfo.uid);
      }
      dispatch({
        type: FETCH_CARS_SUCCESS,
        payload: arr
      });
    };

    const loadViaRest = async () => {
      let loaded = false;
      try {
        const { getValidAuthToken } = require("./authactions");
        let token = await getValidAuthToken();
        const rtdbBase = (firebase.config?.databaseURL || 'https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app').replace(/\/$/, '');
        if (token && userInfo?.uid) {
          const urls = [];
          if (userInfo.usertype === 'driver') {
            urls.push(`${rtdbBase}/cars.json?auth=${token}&orderBy="driver"&equalTo="${userInfo.uid}"`);
            urls.push(`${rtdbBase}/cars.json?auth=${token}&orderBy="driverId"&equalTo="${userInfo.uid}"`);
          } else if (userInfo.usertype === 'fleetadmin') {
            urls.push(`${rtdbBase}/cars.json?auth=${token}&orderBy="fleetadmin"&equalTo="${userInfo.uid}"`);
          } else {
            urls.push(`${rtdbBase}/cars.json?auth=${token}`);
          }

          for (const u of urls) {
            try {
              let res = await fetch(u);
              if (res.status === 401) {
                token = await getValidAuthToken(true);
                if (token) {
                  res = await fetch(u.replace(/auth=[^&]+/, `auth=${token}`));
                }
              }
              if (res.ok) {
                const data = await res.json();
                if (data && typeof data === 'object') {
                  Object.keys(data).forEach(k => {
                    if (data[k] && typeof data[k] === 'object') {
                      carsById.set(k, { ...data[k], id: k });
                      loaded = true;
                    }
                  });
                }
              }
            } catch (_) {}
          }
          if (loaded) {
            emitCars();
          }
        }
      } catch (e) {
        console.warn("[caractions] REST fallback error:", e?.message);
      }
      return loaded;
    };

    if (!auth?.currentUser) {
      loadViaRest();
    }

    if (carsRef) {
      try {
        // [LEAK_PREVENTION] Nettoyer tout écouteur existant pour éviter les empilements
        try {
          if (activeCarsQuery) { off(activeCarsQuery); activeCarsQuery = null; }
          if (activeDriverIdQuery) { off(activeDriverIdQuery); activeDriverIdQuery = null; }
          if (activeDriverQuery) { off(activeDriverQuery); activeDriverQuery = null; }
        } catch (_) {}

        if (userInfo?.usertype === 'driver') {
          // Listen to both driverId and driver queries to support all legacy and modern car records
          const ingest = (snapshot) => {
            if (snapshot && snapshot.val()) {
              const val = snapshot.val();
              Object.keys(val).forEach(k => {
                if (val[k] && typeof val[k] === 'object') {
                  carsById.set(k, { ...val[k], id: k });
                }
              });
              emitCars();
            }
          };

          const qDriverId = carsRefDriverId ? carsRefDriverId(userInfo.uid) : carsRef(userInfo.uid, 'driver');
          const qDriver = carsRefDriver ? carsRefDriver(userInfo.uid) : (carsRef(userInfo.uid, 'driver'));

          let snapCount = 0;
          const onDone = () => {
            snapCount++;
            if (snapCount >= 2 && carsById.size === 0) {
              loadViaRest().then(ok => {
                if (!ok && carsById.size === 0) {
                  dispatch({ type: FETCH_CARS_SUCCESS, payload: [] });
                }
              });
            }
          };

          activeDriverIdQuery = qDriverId;
          onValue(qDriverId, (snap) => {
            ingest(snap);
            onDone();
          }, async (err) => {
            console.warn("[caractions] qDriverId error:", err?.message);
            onDone();
          });

          if (carsRefDriver) {
            activeDriverQuery = qDriver;
            onValue(qDriver, (snap) => {
              ingest(snap);
              onDone();
            }, async (err) => {
              console.warn("[caractions] qDriver error:", err?.message);
              onDone();
            });
          }
        } else {
          const targetCarsQuery = carsRef(userInfo.uid, userInfo?.usertype);
          activeCarsQuery = targetCarsQuery;
          onValue(targetCarsQuery, snapshot => {
            if (snapshot.val()) {
              let data = snapshot.val();
              Object.keys(data).forEach(i => {
                if (data[i] && typeof data[i] === 'object') {
                  carsById.set(i, { ...data[i], id: i });
                }
              });
              emitCars();
            } else {
              loadViaRest().then(ok => {
                if (!ok && carsById.size === 0) {
                  dispatch({
                    type: FETCH_CARS_SUCCESS,
                    payload: []
                  });
                }
              });
            }
          }, async (error) => {
            console.warn("[caractions] onValue error, falling back to REST:", error?.message);
            const ok = await loadViaRest();
            if (!ok && carsById.size === 0) {
              dispatch({
                type: FETCH_CARS_FAILED,
                payload: error?.message || "No cars"
              });
            }
          });
        }
      } catch (_) {
        loadViaRest();
      }
    }
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      config,
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = firebase;

    if (car && typeof car === 'object') {
      if (car.driver && !car.driverId) car.driverId = car.driver;
      if (car.driverId && !car.driver) car.driver = car.driverId;
    }

    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });

    const RTDB_URL = (config?.databaseURL || firebase.config?.databaseURL || 'https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app').replace(/\/$/, '');

    const executeRestFallback = async (methodType, path, body = null) => {
      try {
        const { getValidAuthToken } = require("./authactions");
        let token = await getValidAuthToken();
        if (!token) return false;
        let url = `${RTDB_URL}/${path}.json?auth=${token}`;
        let options = { method: methodType };
        if (body) {
          options.headers = { "Content-Type": "application/json" };
          options.body = JSON.stringify(body);
        }
        let res = await fetch(url, options);
        if (res.status === 401) {
          token = await getValidAuthToken(true);
          if (token) {
            url = `${RTDB_URL}/${path}.json?auth=${token}`;
            res = await fetch(url, options);
          }
        }
        return res.ok;
      } catch (e) {
        console.warn("[caractions] REST operation error:", e?.message);
        return false;
      }
    };

    if (method === 'Add') {
      let added = false;
      try {
        if (carAddRef) {
          await push(carAddRef, car);
          added = true;
        }
      } catch (err) {
        console.warn("[caractions] SDK Add error, falling back to REST:", err?.message);
      }
      if (!added) {
        await executeRestFallback("POST", "cars", car);
      }
    } else if (method === 'Delete') {
      let deleted = false;
      try {
        if (carEditRef && car?.id) {
          await remove(carEditRef(car.id));
          deleted = true;
        }
      } catch (err) {
        console.warn("[caractions] SDK Delete error, falling back to REST:", err?.message);
      }
      if (!deleted && car?.id) {
        await executeRestFallback("DELETE", `cars/${car.id}`);
      }
      // Detach vehicle reference from driver if assigned
      if (car?.driver || car?.driverId) {
        const driverId = car.driver || car.driverId;
        try {
          if (driverId) {
            await executeRestFallback("PATCH", `users/${driverId}`, {
              vehicleNumber: null,
              vehicleMake: null,
              vehicleModel: null,
              driverActiveStatus: false
            });
          }
        } catch (_) {}
      }
    } else if (method === 'UpdateImage') {
      await uploadBytesResumable(carImage(car.id), car.car_image);
      let image = await getDownloadURL(carImage(car.id));
      let data = car;
      data.car_image = image;
      let updated = false;
      try {
        if (carEditRef && car?.id) {
          await set(carEditRef(car.id), data);
          updated = true;
        }
      } catch (err) {
        console.warn("[caractions] SDK UpdateImage error, falling back to REST:", err?.message);
      }
      if (!updated && car?.id) {
        await executeRestFallback("PATCH", `cars/${car.id}`, data);
      }
    } else {
      let updated = false;
      const { id: _ignoredId, ...carFields } = car || {};
      try {
        if (carEditRef && car?.id) {
          await update(carEditRef(car.id), carFields);
          updated = true;
        }
      } catch (err) {
        console.warn("[caractions] SDK Update error, falling back to REST:", err?.message);
      }
      if (!updated && car?.id) {
        await executeRestFallback("PATCH", `cars/${car.id}`, carFields);
      }
    }
  }

  export const updateUserCarWithImage = (newData, blob) => (dispatch) => {
    const {
      auth,
      carAddRef,
      singleUserRef,
      carImage
    } = firebase;

    var carId = push(carAddRef).key;

    uploadBytesResumable(carImage(carId),blob).then(() => {
      blob.close()
      return getDownloadURL(carImage(carId))
    }).then((url) => {
      newData.car_image = url;
      set(child(carAddRef, carId),newData )
    })
  };

  /**
   * Mise en service ATOMIQUE d'un véhicule pour un chauffeur :
   * 1. Vérifie formellement que le véhicule sélectionné appartient à ce chauffeur.
   * 2. Désactive les autres véhicules de CE chauffeur (sans toucher aux véhicules des autres).
   * 3. Met à jour le véhicule sélectionné (active: true) et le profil chauffeur (/users/$uid) dans une SEULE transaction multi-chemins.
   * 4. Conserve l'horodatage réel de la mesure GPS sans inventer de faux horodatage si realGps est frais.
   */
  export const setActiveVehicleAtomic = (driverUid, selectedCar, allCars = [], realGps = null) => async (dispatch, getState) => {
    const { auth, config, database } = firebase;
    const uid = driverUid || auth?.currentUser?.uid;

    const { updates, computedCarTypes } = buildActiveVehicleAtomicPayload(uid, selectedCar, allCars, realGps);

    // 7. Exécution de la mise à jour multi-chemins atomique
    let success = false;
    try {
      if (database) {
        const dbRootRef = ref(database);
        await update(dbRootRef, updates);
        success = true;
      }
    } catch (sdkErr) {
      console.warn("[setActiveVehicleAtomic] SDK multi-path update warning:", sdkErr.message);
    }

    if (!success) {
      try {
        const { getValidAuthToken } = require("./authactions");
        let token = await getValidAuthToken();
        const rtdbBase = (config?.databaseURL || firebase.config?.databaseURL || 'https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app').replace(/\/$/, '');
        if (token) {
          let res = await fetch(`${rtdbBase}/.json?auth=${token}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updates)
          });
          if (res.status === 401) {
            token = await getValidAuthToken(true);
            if (token) {
              res = await fetch(`${rtdbBase}/.json?auth=${token}`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updates)
              });
            }
          }
          success = res.ok;
        }
      } catch (restErr) {
        console.warn("[setActiveVehicleAtomic] REST fallback warning:", restErr.message);
      }
    }

    // 8. Synchronisation immédiate du state Redux auth.profile
    try {
      const state = typeof getState === 'function' ? getState() : (store ? store.getState() : {});
      const currentProfile = state?.auth?.profile;
      if (currentProfile && currentProfile.uid === uid) {
        const updatedProfile = {
          ...currentProfile,
          activeCarId: selectedCar.id,
          carType: (selectedCar.carType || '').trim(),
          carTypes: computedCarTypes,
          vehicleNumber: selectedCar.vehicleNumber || "",
          vehicleMake: selectedCar.vehicleMake || "",
          vehicleModel: selectedCar.vehicleModel || "",
          car_image: selectedCar.car_image || "",
          updatedAt: Date.now()
        };
        dispatch({ type: "FETCH_USER_SUCCESS", payload: updatedProfile });
      }
    } catch (_) {}

    return { success, activeCarId: selectedCar.id, carType: selectedCar.carType };
  };

  /**
   * Passage Hors Service ATOMIQUE :
   * Met à jour driverActiveStatus: false et supprime immédiatement la position dans /locations/$uid
   * en une SEULE transaction multi-chemins.
   */
  export const setDriverOfflineAtomic = (driverUid) => async (dispatch, getState) => {
    const { auth, config, database } = firebase;
    const uid = driverUid || auth?.currentUser?.uid;
    if (!uid) return { success: false };

    const updates = buildDriverOfflineAtomicPayload(uid);

    let success = false;
    try {
      if (database) {
        const dbRootRef = ref(database);
        await update(dbRootRef, updates);
        success = true;
      }
    } catch (sdkErr) {
      console.warn("[setDriverOfflineAtomic] SDK update warning:", sdkErr.message);
    }

    if (!success) {
      try {
        const { getValidAuthToken } = require("./authactions");
        let token = await getValidAuthToken();
        const rtdbBase = (config?.databaseURL || firebase.config?.databaseURL || 'https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app').replace(/\/$/, '');
        if (token) {
          let res = await fetch(`${rtdbBase}/.json?auth=${token}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updates)
          });
          if (res.status === 401) {
            token = await getValidAuthToken(true);
            if (token) {
              res = await fetch(`${rtdbBase}/.json?auth=${token}`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updates)
              });
            }
          }
          success = res.ok;
        }
      } catch (_) {}
    }

    try {
      const state = typeof getState === 'function' ? getState() : (store ? store.getState() : {});
      const currentProfile = state?.auth?.profile;
      if (currentProfile && currentProfile.uid === uid) {
        dispatch({ type: "FETCH_USER_SUCCESS", payload: { ...currentProfile, driverActiveStatus: false } });
      }
    } catch (_) {}

    return { success };
  };